<template>
    <div>
        <!-- <b-modal
            v-model="isModalVisible"
            id="message-modal"
            hide-footer
            :title="model.id ? 'View Message' : 'Add Message'"
            :close-on-backdrop="false"
            @hide="promptSaveMessage"
        > -->
        <b-modal
        v-model="isModalVisible"
        id="message-modal"
        hide-footer
        :title="model.id ? 'View Message' : 'Add Message'"
        :close-on-backdrop="false"
    >
            <b-form-group
                id="fieldset-received"
                label="Received"
                label-cols="3"
                label-class="font-weight-bold pt-0"
                v-if="!!model.id"
            >
                {{ model.created_at | displayTime }}
            </b-form-group>
            <b-form-group
                id="fieldset-sender"
                label="Sender"
                label-cols="3"
                label-class="font-weight-bold pt-0"
                v-if="!!model.id"
            >
                {{ model.user | displayUser }}
            </b-form-group>
            <b-form-group
                id="fieldset-1"
                label="Message"
                label-for="input-content"
                label-cols="3"
                label-class="font-weight-bold pt-0"
            >
                <b-form-textarea
                    :disabled="!!model.id"
                    id="input-content"
                    v-model="model.content"
                    placeholder="Enter Message..."
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </b-form-group>
            <b-button
                size="sm"
                @click="isModalVisible = false"
                variant="warning"
                class="mr-3"
                >Close</b-button
            >
            <b-button
                v-show="!model.id"
                size="sm"
                @click="createMessage"
                v-if="hasPermissionCreate"
                :disabled="submitting ? true : false"
                variant="primary"
                >Add Message</b-button
            >
        </b-modal>
        <b-button
            size="sm"
            variant="primary"
            v-if="hasPermissionCreate"
            @click="
                model.content = ''
                model.id = null
                isModalVisible = true
            "
            >Add Message</b-button
        >
        <b-table
            id="orderTable"
            :items="messages"
            :fields="fields"
            :busy="tableLoading"
            small
            striped
            selectable
            responsive
            show-empty
            ref="selectableTable"
        >
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

            <template #empty>
                <h4 v-html="emptyText"></h4>
            </template>
            <template #emptyfiltered>
                <h4 v-html="emptyText"></h4>
            </template>

            <template #cell(actions)="{ item }">
                <b-button
                    size="sm"
                    v-if="hasPermissionView"
                    @click="viewNote(item)"
                    class="mr-2"
                    variant="primary"
                >
                    View
                </b-button>
                <b-button
                    size="sm"
                    variant="warning"
                    v-if="hasPermissionDelete"
                    @click="deleteMessage(item.hash)"
                    :disabled="submitting ? true : false"
                    >{{ 'Delete' }}</b-button
                >
            </template>

            <template #cell(id)="{ index }">
                <h6>
                    {{ index + 1 }}
                </h6>
            </template>

            <template #cell(content)="{ value }">
                <h6 class="d-flex flex-wrap">
                    <!-- {{ value.length > 40 ? value.slice(0, 40) + '---' : value }} -->
                    {{ value }}
                </h6>
            </template>

            <template #cell(created_at)="{ value }">
                <h6>{{ value | displayTime(new Date()) }}</h6>
            </template>

            <template #cell(user_id)="{ item }">
                <h6>
                    {{ item.user | displayUser }}
                </h6>
            </template>
        </b-table>
    </div>
</template>

<script>
// import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-notes',
    mixins: [popupMixins, permissionsMixins],

    data() {
        return {
            model: {},
            isModalVisible: false,
            messageCreated: false,
            tableLoading: false,
            submitting: false,
            componentName: 'Message',
            fields: [
                {
                    key: 'id',
                    label: '',
                     class:"id_class"
                },
                {
                    key: 'actions',
                    label: '',
                    class:"actionButton_class"
                },
                {
                    key: 'content',
                    label: 'Messages',
                    class:"w-50"
                },

                {
                    key: 'created_at',
                    label: 'Received',
                    class:"created_at_class"
                },
                {
                    key: 'user_id',
                    label: 'Sender',
                    class:"user_id_class"
                },
            ],
            emptyText: '<h4>There are no messages</h4>',
        }
    },
    filters: {
        displayTime(date) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            console.log('timezone', timezone)
            if (date) {
                return new Date(date).toLocaleString('en-US', {
                    timeZone: timezone,
                })
            } else {
                return ''
            }
        },

        displayUser(user) {
            if (user) {
                const name = user.first_name + ' ' + user.last_name
                return (user.is_customer_user ? 'Client' : 'Agent') + ':' + name
            } else {
                return 'self'
            }
        },
    },
    computed: {
        order() {
            return this.$store.state.orders.item
        },
        messages() {
            const messages = this.$store.state.orderMessagesStore.messages
            console.log('message -- ', messages)
            return messages
        },
    },
    watch: {
        'order.notes': {
            //load items
            handler: function (messages) {
                this.$store.dispatch('orderMessagesStore/load', messages)
            },
            deep: true,
        },
    },
    mounted() {
        const { notes } = this.order
        this.messageCreated = false
        this.$store.dispatch('orderMessagesStore/load', notes || [])
    },
    methods: {
        viewNote(item) {
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isModalVisible = true
        },
        formatDate(date) {
            var hours = date.getHours()
            var minutes = date.getMinutes()
            var ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours ? hours : 12 // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes
            var strTime = hours + ':' + minutes + ' ' + ampm
            return (
                date.getMonth() +
                1 +
                '/' +
                date.getDate() +
                '/' +
                date.getFullYear() +
                '  ' +
                strTime
            )
        },
        // async promptSaveMessage(bvModalEvent) {
        //     if (this.model.content && !this.messageCreated) {
        //         bvModalEvent.preventDefault('message-modal')
        //         this.genericToast(
        //             'Message',
        //             'Unsaved',
        //             'warning',
        //             'Please save your message before continuing'
        //         )
        //         // await ('Message Unsaved',
        //         // 'You have started to enter a message, are you sure you would like to close thwithout saving?').then(
        //         //     result => {
        //         //         console.log('message result', result)
        //         //         if (!result) {
        //         //             this.$bvModal.hide('message-modal')
        //         //         }
        //         //     }
        //         // )
        //     } else {
        //         this.isModalVisible = false
        //         // Reset Message Created State
        //         this.messageCreated = false
        //     }
        // },

        createMessage() {
            const {
                model: { content },
            } = this
            const message = { content }
            this.$store.dispatch('orderMessagesStore/merge', message)
            this.genericToast(
                this.componentName,
                'Updated',
                'success',
                `${this.componentName} has been successfully saved`
            )
            this.isModalVisible = false
            this.messageCreated = true
        },
        deleteMessage(hash) {
            this.$store.dispatch('orderMessagesStore/delete', hash)
            this.genericToast(
                this.componentName,
                'Deleted',
                'success',
                `${this.componentName} has been successfully deleted`
            )
            this.$emit('success', this.componentName, 'Deleted')
        },
    },
}
</script>

<style>
.text-wrap {
    white-space: normal !important;
  }
  .created_at_class , .user_id_class{
    width:20% !important
  }
  .id_class{
    width:2% !important
  }
  .actionButton_class{
    width:8% !important
  }
</style>
